var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2LaundryRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM38 31.32A5.6 5.6 0 0043.59 27L57 29.93V38h-8v20H27V38h-8v-8.07L32.41 27A5.6 5.6 0 0038 31.32z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Laundry_room.fa29ded5.svg";
export { SvgE2LaundryRoom as ReactComponent };